import * as React from 'react';

import { FavoriteButtonMobileContainer } from '../../FavoriteButton';
import { MotivationPopupMobileContainer } from '../../MotivationPopup';

export const FavoriteButtonMobileWithMotivation: React.VFC = () => {
  return (
    <>
      <FavoriteButtonMobileContainer />
      <MotivationPopupMobileContainer />
    </>
  );
};
